<template>
    <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
                <v-flex xs12 sm4 offset-sm1>
                    <v-select
                            v-model="homogenio.companyJob"
                            :items="$store.state.companyJobs"
                            label="Puesto de trabajo"
                            item-text="name"
                            item-value="name"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm4 offset-sm1>
                    <v-select
                            v-model="homogenio.companyAgency"
                            :items="$store.state.companyAgencies"
                            label="Agencia"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm4 offset-sm1>
                    <v-select
                            v-model="homogenio.type"
                            :items="$store.state.types"
                            label="Tipos"
                            v-on:change="getElementsByType"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm4 offset-sm1>
                    <v-select
                            v-model="homogenio.element"
                            :items="this.itemsElements"
                            label="Tipos de Elementos"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm4 offset-sm1>
                    <v-select
                            v-model="homogenio.group"
                            :items="this.itemsGroup"
                            label="Grupo"
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm6 offset-sm4>
                    <div>
                        <v-btn :disabled="!valid"
                               @click="saveDataHomogenio" large color="primary">Guardar</v-btn>
                    </div>
                </v-flex>
            </v-layout>
            <br>
            <v-data-table
                    :headers="headersHomogenio"
                    :items="this.$store.state.gruposHomogenio"
                    class="elevation-1"
                    sort-icon="mdi-menu-down"
                    :search="search"
            >
                <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{ props.item.companyJob.name}}</td>
                    <td class="text-xs-left">{{ props.item.companyAgency.name }}</td>
                    <td class="text-xs-left">{{ props.item.type.name }}</td>
                    <td class="text-xs-left">{{ props.item.element.name }}</td>
                    <td class="text-xs-left">{{ props.item.group }}</td>
                    <td>
                        <v-tooltip top >
                            <v-btn fab dark small @click="deleteItemHomogenio(props.item)" slot="activator" color="primary">
                                <v-icon dark>delete</v-icon>
                            </v-btn>
                            <span>Eliminar</span>
                        </v-tooltip>
                    </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    No se han encontrado resultados para "{{ search }}".
                </v-alert>
            </v-data-table>
        </v-form>
    </v-container>
</template>
<script>

    import GrupoHomogenioExposicion from "../../../model/GrupoHomogenioExposicion";

    export default {
        props: ['company'],
        data() {
            return {
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                jobs:[],
                dialogSuccess:false,
                homogenio:new GrupoHomogenioExposicion(),
                homogenios:[],
                itemsGroup: ['Baja exposición', 'Media exposición', 'Alta exposición'],
                itemsElements: [],
                headersHomogenio: [
                    { text: 'Puesto de trabajo', value: 'code' },
                    { text: 'Agencia', value: 'agency' },
                    { text: 'Tipo', value: 'type' },
                    { text: 'Elemento', value: 'element' },
                    { text: 'Grupo', value: 'group' },
                    { text: 'Acciones', value: 'editar' },

                ],
            };
        },
        methods: {
            getElementsByType(){
                this.$store.dispatch('getElementsByType',this.homogenio.type.id).then(response => {
                    this.itemsElements = this.$store.state.elements
                }, error => {
                    this.$store.state.progress = false
                    this.$store.state.dialogError = true
                })
            },
            saveDataHomogenio(){
                if(this.homogenio.companyJob!="" && this.homogenio.companyAgency!="" && this.homogenio.type!="" && this.homogenio.element!="" && this.homogenio.group!="") {
                    this.$store.state.company = this.homogenio.companyAgency.company
                    this.homogenio.company = this.homogenio.companyAgency.company
                    this.$store.dispatch('addGruposHomogenio', this.homogenio).then(response => {
                        this.homogenios = this.$store.state.gruposHomogenio
                        this.homogenio = new GrupoHomogenioExposicion();
                    }, error => {
                        this.$store.state.progress = false
                        this.$store.state.dialogError = true
                    })
                }else{
                    this.$store.state.dialogErrorMessage = "Debe llenar todos los campos para poder agregar un nuevo registro."
                    this.$store.state.progress = false
                    this.$store.state.dialogError = true
                }
            },
            deleteItemHomogenio (item) {
                this.editedIndex = this.$store.state.gruposHomogenio.indexOf(item)
                this.gruposHomogenio = Object.assign({}, item)
                confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deleteGruposHomogenio', this.gruposHomogenio.id)
            }
        },
        computed: {}
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/company/grupoHomogenioExposicion/GrupoHomogenioExposicion.vue